export const PATHS = {
  SIGN_IN: 'sign-in',
  PASSWORD_RECOVERY: 'password-recovery',
  REGISTER: 'register',
  PASSWORD: './password',
};
